<template>
  <div class="video-detail-page">
    <!-- 视频播放器 -->
    <div class="video-container">
      <video
        ref="videoPlayer"
        :src="videoUrl"
        :poster="posterUrl"
        controls
        playsinline
        webkit-playsinline
        x5-playsinline
        class="video-player"
        @play="onVideoPlay"
        @pause="onVideoPause"
        @ended="onVideoEnded"
      >
        您的浏览器不支持视频播放
      </video>
    </div>

    <!-- 视频信息卡片 -->
    <div class="info-card">
      <h1 class="video-title">{{ title }}</h1>

      <div class="video-stats">
        <div class="stat-item">
          <div class="stat-icon stat-icon--green">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 4L12 8L6 12V4Z" fill="currentColor"/>
            </svg>
          </div>
          <span>播放中</span>
        </div>
        <div class="stat-item">
          <div class="stat-icon stat-icon--yellow">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 1L10 6H15L11 9L12.5 14L8 11L3.5 14L5 9L1 6H6L8 1Z" fill="currentColor"/>
            </svg>
          </div>
          <span>精选推荐</span>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="action-buttons">
        <div class="action-btn action-btn--primary" @click="replayVideo">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 4V1L6 5L10 9V6C13.31 6 16 8.69 16 12C16 15.31 13.31 18 10 18C6.69 18 4 15.31 4 12H2C2 16.42 5.58 20 10 20C14.42 20 18 16.42 18 12C18 7.58 14.42 4 10 4Z" fill="currentColor"/>
          </svg>
          <span>重新播放</span>
        </div>
        <div class="action-btn action-btn--secondary" @click="goBack">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M4 4H8V8H4V4ZM12 4H16V8H12V4ZM4 12H8V16H4V12ZM12 12H16V16H12V12Z" fill="currentColor"/>
          </svg>
          <span>更多视频</span>
        </div>
      </div>
    </div>

    <!-- 小贴士 -->
    <div class="tips-section">
      <div class="tips-header">
        <span class="tips-icon">🌟</span>
        <span class="tips-title">练习小贴士</span>
      </div>
      <div class="tips-content">
        <div class="tip-item">
          <span class="tip-dot tip-dot--green"></span>
          <span>每天坚持练习10-15分钟效果更好</span>
        </div>
        <div class="tip-item">
          <span class="tip-dot tip-dot--yellow"></span>
          <span>动作要轻柔，不要过度用力</span>
        </div>
        <div class="tip-item">
          <span class="tip-dot tip-dot--blue"></span>
          <span>练习时保持呼吸均匀</span>
        </div>
        <div class="tip-item">
          <span class="tip-dot tip-dot--pink"></span>
          <span>如有不适请立即停止并咨询医生</span>
        </div>
      </div>
    </div>

    <!-- 底部装饰 -->
    <div class="page-footer">
      <div class="footer-decoration">
        <span class="footer-star">⭐</span>
        <span class="footer-star">🌈</span>
        <span class="footer-star">💪</span>
      </div>
      <p class="footer-text">加油，你是最棒的！</p>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'SpineExerciseVideoDetailPage',
  data () {
    return {
      videoUrl: '',
      posterUrl: '',
      title: '脊柱保健操',
      isPlaying: false
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      const query = this.$route.query

      if (query.videoUrl) {
        this.videoUrl = decodeURIComponent(query.videoUrl)
      }

      if (query.title) {
        this.title = query.title
      }

      if (query.poster) {
        this.posterUrl = decodeURIComponent(query.poster)
      }

      console.log('视频详情页初始化:', {
        videoUrl: this.videoUrl,
        title: this.title
      })
    },

    onVideoPlay () {
      this.isPlaying = true
      console.log('视频开始播放')
    },

    onVideoPause () {
      this.isPlaying = false
      console.log('视频暂停')
    },

    onVideoEnded () {
      this.isPlaying = false
      Toast({
        message: '太棒了！视频播放完成 🎉',
        position: 'middle',
        duration: 2000
      })
    },

    replayVideo () {
      const video = this.$refs.videoPlayer
      if (video) {
        video.currentTime = 0
        video.play()
      }
    },

    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.video-detail-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #1B5E20 0%, #2E7D32 10%, #E8F5E9 30%, #F1F8E9 60%, #FFFDE7 100%);
  padding-bottom: 40px;
}

/* 视频容器 */
.video-container {
  width: 100%;
  background: #000;
}

.video-player {
  width: 100%;
  aspect-ratio: 16 / 9;
  display: block;
  background: #000;
}

/* 信息卡片 */
.info-card {
  margin: -20px 16px 20px;
  padding: 24px 20px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 10;
}

.video-title {
  font-size: 20px;
  font-weight: 700;
  color: #2E7D32;
  margin: 0 0 16px;
  line-height: 1.4;
}

.video-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
}

.stat-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon--green {
  background: linear-gradient(135deg, #C8E6C9 0%, #A5D6A7 100%);
  color: #2E7D32;
}

.stat-icon--yellow {
  background: linear-gradient(135deg, #FFF9C4 0%, #FFEB3B 100%);
  color: #F57F17;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 12px;
}

.action-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.action-btn:active {
  transform: scale(0.96);
}

.action-btn--primary {
  background: linear-gradient(135deg, #66BB6A 0%, #43A047 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.action-btn--secondary {
  background: linear-gradient(135deg, #FFF9C4 0%, #FFF176 100%);
  color: #5D4037;
  box-shadow: 0 4px 12px rgba(255, 235, 59, 0.3);
}

/* 小贴士区域 */
.tips-section {
  margin: 0 16px 20px;
  padding: 20px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.tips-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.tips-icon {
  font-size: 20px;
}

.tips-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.tips-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tip-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #555;
  line-height: 1.5;
}

.tip-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.tip-dot--green {
  background: #4CAF50;
}

.tip-dot--yellow {
  background: #FFC107;
}

.tip-dot--blue {
  background: #2196F3;
}

.tip-dot--pink {
  background: #E91E63;
}

/* 底部装饰 */
.page-footer {
  text-align: center;
  padding: 20px;
}

.footer-decoration {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 12px;
}

.footer-star {
  font-size: 24px;
  animation: bounce 2s ease-in-out infinite;
}

.footer-star:nth-child(2) {
  animation-delay: 0.2s;
}

.footer-star:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

.footer-text {
  font-size: 14px;
  color: #81C784;
  margin: 0;
  font-weight: 500;
}

/* 响应式 */
@media (max-width: 360px) {
  .info-card {
    margin: -16px 12px 16px;
    padding: 20px 16px;
  }

  .video-title {
    font-size: 18px;
  }

  .action-btn {
    padding: 12px;
    font-size: 13px;
  }
}
</style>
